import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';
import { AllocationDefinitionImportLine } from '../domain/allocationdefinitionimportline';
import { LookupService } from '../service/lookup.service';
import { AllocationDefinitionService } from '../service/allocationdefinition.service';
import { ReportDefinitionService } from '../service/reportdefinition.service';
import { AllocationDefinitionLine } from '../domain/allocationdefinitionline';
import { LineService } from '../service/line.service';
import { AllocationDefinitionImportLinePreview } from '../domain/allocationdefinitionimportlinepreview';
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AllocationFactorsImportExceptionLog } from '../domain/allocationFactorsImportExceptionLog';
import { Sort, GridComponent, PageSettingsModel, Page, Grid, Filter, FilterService,GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { MessageService } from 'primeng/api';
import { Utils } from 'src/app/utilities/utils';


@Component({
    templateUrl: './allocation-factors-import.component.html'
})
export class AllocationFactorsImportComponent implements OnInit {
    [x: string]: any;

    validatedExcelData: AllocationDefinitionImportLine[] = [];
    validatedExcelDataWithErrors: AllocationDefinitionImportLine[] = [];
    showOnlyDataWithErrors: boolean = false;

    companyId: number;

    validReportCodes: any[];
    validDimensionValues: any[];
    validReportCodeReportRowNo: Map<string, string[]>;


    importDataValidated: boolean = false;
    importDataHasErrors: boolean = false;

    importInProgress: boolean = false;
    importStatus: string;
    linesFailedToImport: any[] = [];
    totals: object = {
        m1: 0,
        m2: 0,
        m3: 0,
        m4: 0,
        m5: 0,
        m6: 0,
        m7: 0,
        m8: 0,
        m9: 0,
        m10: 0,
        m11: 0,
        m12: 0,
    };
    sumError: boolean = false;
    errorCount: number = 0;
    items: AllocationDefinitionLine[] = [];
    year: object;
    id: string;
    fileNameText: string;
    selectedFile: File | null = null;
    action = 'Preview'; // Default action
    readyForImport: boolean = false;
    cancelEnabled:boolean= false;

    public dataManager: DataManager | null = null;
    public dataManagerError: DataManager | null = null;
    public guid: string | null = null;
    public guidText: string | null = null;
    public isDataAvailable: boolean = false;

    public data: AllocationDefinitionImportLinePreview[] = [];
    public countError: number = 0;
    public tabItems: Object[] = [];
    public headerText: Object[] = [{ 'text': 'Twitter' }, { 'text': 'Facebook' }, { 'text': 'WhatsApp' }];
    public pageSettings = { pageSize: 100 };
    public initialPage: Object;
    public userName: string;
    public filterOptions: Object = { type: 'Excel' };
    public groupSettings: GroupSettingsModel;



    constructor(
        private lookupService: LookupService,
        private route: ActivatedRoute,
        private router: Router,
        private allocationDefinitionService: AllocationDefinitionService,
        private reportDefinitionService: ReportDefinitionService,
        private lineService: LineService,
        private jwtHelper: JwtHelperService,
        private messageService: MessageService
    ) {
        Grid.Inject(Filter, Page, Sort);
        
        // this.headerText = [{ 'text': 'Twitter' }, { 'text': 'Facebook' },{ 'text': 'WhatsApp' }];
    }

    ngOnInit() {
        this.initialPage = { pageSizes: true, pageCount: 4 };
        this.companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        this.userName = this.getUserName();
        this.groupSettings = { columns: ["AllocationItem","ReportRowNumber","ReportCode","SourceDimesion", "SourceDimensionCode","SourceDimensionValue","SourceDimensionValueCode"] };

    }

    getUserName() {
        const token = this.jwtHelper.decodeToken(localStorage.getItem('jwt'));

        return token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    }

    readExcel(event: any): void {
        this.reset();
        const files: File[] = event.files;

        if (files.length > 0) {
            this.selectedFile = files[0];

            if (this.guid != null) {
                this.fileNameText = "File Name: " + this.selectedFile.name + ",";
            } else {
                this.fileNameText = "File Name: " + this.selectedFile.name;
            }

        } else {
            this.fileNameText = "";
        }

    }

    reset(): void {
        this.data = null;
        this.countError = 0;
        this.guid = null;
        this.guidText = "";
        this.fileNameText = "";
        this.selectedFile = null;
        this.readyForImport = false;
        this.cancelEnabled = false;
        this.dataManager = null;
        this.dataManagerError = null;

    }



    async uploadFile(): Promise<void> {
        if (!this.selectedFile) {
            alert('Please select a file to upload.');
            return;
        }

        try {
            this.importInProgress = true;
            const response = await this.allocationDefinitionService.uploadExcel(this.selectedFile, this.userName, this.companyId, 'Preview')
                .then((response) => {
                    this.fileNameText = "File Name: " + this.selectedFile.name + ",";
                    this.guid = response.SessionGuid
                    this.guidText = "Session GUID: " + this.guid;
                    alert('Upload successful with GUID: ' + this.guid);
                    this.initializeGridDataManager(this.guid);
                    this.initializeGridDataManagerError(this.guid);

                    // this.readyForImport = true;
                })
                .catch(error => {
                    this.messageService.add({ severity: 'error', summary: 'Upload failed', detail: Utils.extractSQLError(error.error) })
                    this.readyForImport = false;
                });

            //this.importInProgress = false;

        } catch (error) {
            //this.importInProgress = false;
            console.error('Upload error:', error);
            alert('Failed to upload file. Please try again.');
            // ovdhe heanldaj exception
        }
     finally {
        this.importInProgress = false; // Hide spinner
    }
    }

    async importFile(): Promise<void> {
        this.importInProgress = true;
        const response = await this.allocationDefinitionService.processExcel(this.userName, this.companyId, 'Import', this.guid)
            .then((response) => {
                this.reset();
                // ovdhe heanldaj exception
                this.importInProgress = false; // Hide spinner
            })
            .catch(error => {
                this.importInProgress = false; // Hide spinner
                this.messageService.add({ severity: 'error', summary: 'Import failed', detail: Utils.extractSQLError(error.error) })
            })

    }

    async cancel(): Promise<void> {
        this.importInProgress = true;
        const response = await this.allocationDefinitionService.processExcel(this.userName, this.companyId, 'Cancel', this.guid)
            .then((response) => {
                this.reset();
                this.importInProgress = false;
            })
            .catch(error => {
                this.importInProgress = false;
                this.messageService.add({ severity: 'error', summary: 'Cancel failed', detail: Utils.extractSQLError(error.error) })
            });

    }


    rowDataBound(args: any): void {
        if (args.row) {
            if (args.data.ImportStatusID == 3) {
                args.row.classList.add('status-error');
            } else if (args.data.ImportStatusID == 2) {
                args.row.classList.add('status-warning');
            } else {

            }
        }
        const gridElement = document.getElementById('GridError');
        const grid = (gridElement as any).ej2_instances[0];

        const gridElementData = document.getElementById('GridData');
        const gridPreview = (gridElementData as any).ej2_instances[0];

        if (gridPreview) {
            const rowCountData = gridPreview.getCurrentViewRecords().length;
            if(rowCountData>0)
                {
                    if (grid) {
 
                        const rowCount = grid.getCurrentViewRecords().length;
                        this.countError = rowCount;
                        if (rowCount > 0) {
                            this.readyForImport = false;
                            this.cancelEnabled = true;
                        }else{
                            this.readyForImport = true;
                            this.cancelEnabled = true;
                        }
            
                    }
            }else{
                this.readyForImport = false;
                this.cancelEnabled = false;
            }
        }
    }

    initializeGridDataManager(guid: string): void {
        this.dataManager = this.allocationDefinitionService.getDataManager(guid);
    }

    initializeGridDataManagerError(guid: string): void {
        this.dataManagerError = this.allocationDefinitionService.getDataManagerError(guid);
    }

    actionFailure(e: any): void {

        console.log(e.error)
    }

    downloadTemplate() {
        this.allocationDefinitionService.downloadFile().subscribe({
          next: (blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'AllocationDefinition-Template.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
            this.messageService.add({
                severity: "success",
                summary: "Template downloaded!",
                detail: "Check your download folder for file.",
            });
          },
          error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "File not found",
                    detail: "A sample Excel file is not available.",
                });
          },
        });
      }
   

}
